module.exports = __webpack_public_path__ + "static/media/footer-bg.a067a2a4.svg";